<template>
	<form @submit.prevent="loginFormSubmit" :class="{'form-submitting':form_submitting}" >
		<div class="normal field">
			<label>Email</label>
			<input type="email" name="email" v-model="email" :disabled="invite" data-cy="email-field" required />
		</div>
		<div class="normal field">
			<label>Password</label>
			<input type="password" autocomplete="current-password" name="password" v-model="password" data-cy="password-field" required />
            <div style="margin-top:0.5em" v-if="reset_route" >
    			<router-link :to="reset_route" >I've forgotten my password</router-link>
            </div>
		</div>
		<FormErrors v-if="form_errors.length" :errors="form_errors" />
		<div class="normal form_footer">
            <button class="btn-a" data-cy="submit-button">Login</button>
		</div>
	</form>
</template>


<script>

	import { ref } from "vue";
	import useAuthStore from "../stores/AuthStore";

	import FormErrors from "../components/FormErrors";

	export default {

		props:['invite','to','providerId'],

		components:{
			FormErrors,
		},

		setup(props) {

			// Form vals
			let email = ref('');
			const password = ref('');
			const invite = ref(props.invite);

			if(props.invite){
				email = ref(props.invite.email);
			}

			// States
			const form_submitting = ref(false);
			const field_errors = ref({});
			const form_errors = ref([]);
            const provider_id = ref(props.providerId);

			// Methods
			var { attemptLogin } = useAuthStore();

			return {
				email,
				password,
				form_submitting,
				field_errors,
				form_errors,
				attemptLogin,
                provider_id,
			};
		},

        computed:{
            reset_route(){
                try {
                    let resolved = this.$router.resolve({name:'Password',query:{email:this.email}});
                    return resolved;
                } catch (error) {

                }
                return false;
            }
        },

        methods:{
			loginFormSubmit(){
				let {email,password,invite} = this;
				if(this.form_submitting) return false;
				this.form_submitting = true;
				this.field_errors = {};
				this.form_errors = [];

				let auth_payload = {email,password, provider: this.provider_id};
                if(invite) auth_payload.invite_id = invite.id;

				this.attemptLogin(auth_payload, this.$route.query.referrer).then(()=>{
					const redirect = this.$route.query.redirect;
					if( redirect && !redirect.includes('://')){
						this.$router.push( redirect );
					} else {
						this.$router.push( this.to || {name:'Dashboard'});
					}
				}).catch(e=>{
					var error = e.toString();
					if((e.response||{}).status == 422 ) error = 'Invalid login';
					this.form_errors = [error];
					this.form_submitting = false;
				}).then(()=>{
                });
			}
		}
	}
</script>
